import React from "react"
import { Link } from "gatsby"
import loanRepayment from "../../assets/images/calc-loan-repayment.svg"
import loancomparison from "../../assets/images/calc-loan-comparison.svg"
import smsfPropertyCalc from "../../assets/images/calc-smsf-property.svg"
import rightArrow from "../../assets/images/right-arrow.svg"
import stampDuty from "../../assets/images/calc-stamp-duty.svg"
import smsfAffordability from "../../assets/images/calc-smsf-affordability.svg"
import homeLoanOffset from "../../assets/images/calc-home-loan-offset.svg"

const TopCalculators = ({ sectionTitle, showMore }) => {
  return (
    <section className="calculator-area">
      <div className="container">
        <div className="section-title">
          <h2>{sectionTitle}</h2>
        </div>

        {/* <div className="row">
          <div className="col-lg-4 col-md-6">
            <Link
              to="/calculators/borrowing-power-calculator"
              className="highlight-calculator"
            >
              <div className="icon">
                <img src={loanRepayment} alt="icon" />
              </div>
              <h3>Borrowing Power Calculator</h3>
              <p>Use your details to estimate how much you can borrow.</p>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6">
            <Link
              to="/calculators/loan-comparison-calculator"
              className="highlight-calculator"
            >
              <div className="icon">
                <img src={loancomparison} alt="icon" />
              </div>
              <h3>Loan Comparison Calculator</h3>
              <p>Adjust rates and terms to compare different home loans.</p>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6">
            <Link
              to="/calculators/property-buying-cost-calculator"
              className="highlight-calculator"
            >
              <div className="icon">
                <img src={smsfPropertyCalc} alt="icon" />
              </div>
              <h3>Property Buying Cost Calculator</h3>
              <p>See what buying will cost you on top of the purchase price.</p>
            </Link>
          </div>

          {showMore ? (
            <div className="col-12">
              <Link to="/calculators" className="more-arrow mt-3">
                More Calculators <img src={rightArrow} alt="arrow icon" />
              </Link>
            </div>
          ) : (
            ""
          )}
        </div> */}
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <Link
              to="/calculators/loan-repayment-calculator"
              className="highlight-calculator"
            >
              <div className="icon">
                <img src={loanRepayment} alt="icon" />
              </div>
              <h3>Loan Repayment Calculator</h3>
              <p>Estimate your home loan repayments and work out how to repay it faster.</p>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6">
            <Link
              to="/calculators/stamp-duty-calculator"
              className="highlight-calculator"
            >
              <div className="icon">
                <img src={stampDuty} alt="icon" />
              </div>
              <h3>Stamp Duty Calculator</h3>
              <p>Find out how much stamp duty you will have to pay on a home.</p>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6">
            <Link
              to="/calculators/loan-comparison-calculator"
              className="highlight-calculator"
            >
              <div className="icon">
                <img src={loancomparison} alt="icon" />
              </div>
              <h3>Loan Comparison Calculator</h3>
              <p>Adujust rates and terms to compare different home loans.</p>
            </Link>
          </div>

          {showMore ? (
            <div className="col-12">
              <Link to="/calculators" className="more-arrow mt-3">
                More Calculators <img src={rightArrow} alt="arrow icon" />
              </Link>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <Link
              to="/calculators/smsf-property-calculator"
              className="highlight-calculator"
            >
              <div className="icon">
                <img src={smsfPropertyCalc} alt="icon" />
              </div>
              <h3>SMSF Property Calculator</h3>
              <p>Estimate your SMSF borrowing power and potential property investment costs.</p>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6">
            <Link
              to="https://apps.oxygenloans.com.au/SMSF/Quote"
              className="highlight-calculator"
              target="_blank"
            >
              <div className="icon">
                <img src={smsfAffordability} alt="icon" />
              </div>
              <h3>SMSF Affordability Calculator</h3>
              <p>Find out how much your SMSF can afford to invest in property.</p>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6">
            <Link
              to="/calculators/home-loan-offset-calculator"
              className="highlight-calculator"
            >
              <div className="icon">
                <img src={homeLoanOffset} alt="icon" />
              </div>
              <h3>Home Loan Offset Calculator</h3>
              <p>Estimate how much interest you will save by using your savings to offset your home loan.</p>
            </Link>
          </div>

          {showMore ? (
            <div className="col-12">
              <Link to="/calculators" className="more-arrow mt-3">
                More Calculators <img src={rightArrow} alt="arrow icon" />
              </Link>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </section>
  )
}

export default TopCalculators
